var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReceiptIcon = function SvgReceiptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M34.834 9.5v3.831c0 2.502-1.584 4.085-4.086 4.085h-5.415V6.349c0-1.758 1.441-3.183 3.199-3.183a6.365 6.365 0 0 1 4.449 1.853 6.373 6.373 0 0 1 1.852 4.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M3.167 11.083v22.166c0 1.314 1.488 2.059 2.533 1.267l2.707-2.027a1.595 1.595 0 0 1 2.09.159l2.629 2.644c.617.617 1.63.617 2.248 0l2.66-2.66a1.57 1.57 0 0 1 2.058-.143l2.708 2.027c1.045.776 2.533.032 2.533-1.267V6.333A3.176 3.176 0 0 1 28.5 3.166h-19C4.75 3.166 3.167 6 3.167 9.499v1.584Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "M9.5 14.25H19M10.688 20.584h7.124",
    opacity: 0.4
  })));
};
export default SvgReceiptIcon;